import { createSelector } from 'async-selector-kit'
import { ICreateLogin } from './reducer'

const rootState = (state: ICreateLogin) => state.createLogin

export const getLoginForm = createSelector(
  rootState,
  (state) => state.loginForm
)
